/* eslint-disable react/no-unescaped-entities */
import images from '@assets/images/index'
import { Flex, Input } from 'antd'

import { Collapse, ResourceList } from '@suntex.fim/ui'

interface FAQItem {
  key: string
  header: string
  content: JSX.Element
}

interface FAQSection {
  title: string
  items: FAQItem[]
}

const faqData: FAQSection[] = [
  {
    title: 'General Information',
    items: [
      {
        key: '1',
        header: "What's New for 2022-2023?",
        content: (
          <div className="faq-content">
            <p>
              Over the Summer we&apos;ve made lots of improvements to the FIRST
              IN MATH that you can&apos;t see, and even more great additions
              that you can see! Here are a few highlights:
            </p>
            <ul>
              <li>
                More content added to the BONUS 7 group of games, with ALGERBA
                TILES joining the other two &lsquo;tile&rsquo; games introduced
                last Spring, — ORDER OF OPERATIONS TILES and FRACTION TILES.
              </li>
              <li>
                A new ALGEBRA GOALS metric is accessible from the player Goals
                Index pages. The Algebra Goals Metric is an overall measure of
                performance on First in Math in eight algebraic categories.
                Hovering over each sector of the ALgebra GI icon provides
                additional information about specific skills being practiced.
              </li>
              <li>
                What Do You Know 2.0 Assigned tests are now available for Grades
                3, 4, 5 & 6! Topics: Multiplication, Addition & Subtraction
                multi-step problems; Fractions; Geometry; Measurement;
                Area/Perimeter; Data Representation. Choose 15-, 30-, or
                60-minute completion window.
              </li>
              <li>
                Several new games were added late last Spring, including
                &lsquo;Pre-K Memory Tiles&rsquo; & &lsquo;K2 Jeweled
                Tiles&rsquo; in K2 World, &lsquo;Money Tiles&rsquo; in
                Measurement World, &lsquo;Early Algebra Tiles&rsquo; in Bonus 1
                and Decimal, Integer & Exponent tile games in Bonus 6! Be sure
                to point them out to your students!!
              </li>
              <li>
                Something that is NOT new is our commitment to you! The minute
                your students are enrolled for Fall 2022 — and throughout the
                school year—we will be by your side to help teachers, students,
                and parents realize the program's many benefits. If you need
                help, let us demonstrate how to use First in Math and integrate
                it easily with your curriculum. Contact 610-253-5255 or
                nancy@firstinmath.com
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '2',
        header: 'How to Get Started as a Team Leader.',
        content: (
          <div className="faq-content">
            <p>
              Registering with the First In Math® Online program ensures that
              your Classroom's progress records will be properly recorded and
              displayed. The first time you log in, we'll walk you through the
              process step-by-step. You can also log in and click Team
              Management (School Management - Admin) link at any time.
            </p>
          </div>
        )
      },
      {
        key: '3',
        header: 'Can I reuse student User IDs from last year this year?',
        content: (
          <div className="faq-content">
            <p>
              No. Subscriptions begin August 1 and end July 31 of each school
              year. Enroll your new class roster as a new team.
            </p>
          </div>
        )
      },
      {
        key: '4',
        header: 'I need additional FIM Teams, what should I do?',
        content: (
          <div className="faq-content">
            <p>
              More Teams can be emailed to you at no charge.
              Admin/Principal/Teacher can email requests for additional teams to
              info@firstinmath.com .
            </p>
            <ul>
              <li>
                NOTE: TEAMS should not be confused with LICENSES. Example: if
                you purchase 200 Student Licenses you can have 10 Teams with 20
                students each, or 7 Teams with 28+ students each. Email requests
                for additional teams to info@firstinmath.com
              </li>
              <li>
                If your school needs to purchase additional LICENSES, contact
                our sales team at 610-253-5255.
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '5',
        header: 'How to get Students started.',
        content: (
          <div className="faq-content">
            <p>
              NEW USERS, click REGISTER STUDENTS (purple Pencil icon), then
              follow instructions. Choose &ldquo;Register class as a
              group&rdquo; or &ldquo;Register students individually&rdquo; to
              add names.
            </p>
          </div>
        )
      },
      {
        key: '6',
        header: 'How to enter additional optional Student Information.',
        content: (
          <div className="faq-content">
            <p>
              From Teacher Homepage, click Team Management then Team Roster link
              to see your students' User IDs and Passwords. Click "EDIT" link at
              right for the student you want to edit; enter optional information
              and click SAVE link.
            </p>
          </div>
        )
      },
      {
        key: '7',
        header: 'What are the blue and gray shapes around the HUB center?',
        content: (
          <div className="faq-content">
            <p>
              A FOCUS MODE configuration containing four focus segments —Early
              (K2), Elementary, Intermediate, Advanced—now appears before the
              Student HUB can be accessed. When clicked, each segment will take
              the child to her/his HUB corresponding to that Focus, placing them
              in grade-level material quickly and easily. We now automatically
              set a Focus Mode for a teacher, but each Teacher retains the
              flexibility to make adjustments, allowing students to work in
              additional or other Focus areas.
            </p>
            <ul>
              <li>
                When the grade level is set either through rostered data (when
                your classroom is created), or if the teacher enters it from the
                Edit Team Info Page, the Focus Mode will be set as follows:
              </li>
              <li>
                When the grade level is set either through rostered data (when
                your classroom is created), or if the teacher enters it from the
                Edit Team Info Page, the Focus Mode will be set as follows:
              </li>
              <li>Grade Focus Mode segments</li>
              <li>K, 1, 2 Early (K2), Elementary</li>
              <li>3, 4 Elementary, Intermediate</li>
              <li>5, 6 Elementary, Intermediate</li>
              <li>7, 8 Intermediate, Advanced</li>
              <li>
                Unassigned, Other, and Grades 9-12 map to FIM Classic Mode (All
                games, 4 segments are selectable).
              </li>
              <li>
                In this case, the Focus Mode selected would determine which
                segments are clickable. A teacher can override the Grade Level
                Focus Mode on their Team from the Focus Mode link the TL
                Homepage. A Teacher can make changes for the entire classroom or
                just override options for a specific student.
              </li>
              <li>
                <i>
                  Example: If a teacher selects Elementary Focus Mode for class,
                  then all students would only be able to click the Elementary
                  segment. If a teacher sets a broader Focus Mode for an
                  individual student, then her/his available segment(s) would
                  reflect those selections.
                </i>
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '8',
        header: 'What is Focus Mode and how can I change it?',
        content: (
          <div className="faq-content">
            <p>
              [Focus
              Mode](https://explore.firstinmath.com/media/35092/what-is-focus-mode.pdf)
              allows you to curate your students&apos; FIM experience. Select
              the appropriate grade level and skill activities for the whole
              class or modify the settings for individual students as needed.
              Change settings or return to defaults at any time by clicking the
              "Focus&quot; link on your Teacher Dashboard (homepage).
            </p>
          </div>
        )
      },
      {
        key: '9',
        header: 'What is the purpose of the Player/Student HUB?',
        content: (
          <div className="faq-content">
            <p>
              Players (students) click the icons to drill down to the games they
              want to play. Icons on the HUB also serve as a way to guide users
              through the program in a systematic order.
            </p>
            <ul>
              <li>
                New users: Have students begin by clicking the yellow icon (Just
                The Facts) located at 12 o'clock, and proceed to other modules
                clockwise around the HUB. When students begin with JUST THE
                FACTS pre-test/post-test module, data populates assessment and
                dashboard tools, so you can track and observe proficiencies and
                trends.
              </li>
              <li>
                New users: Have students begin by clicking the yellow icon (Just
                The Facts) located at 12 o'clock, and proceed to other modules
                clockwise around the HUB. When students begin with JUST THE
                FACTS pre-test/post-test module, data populates assessment and
                dashboard tools, so you can track and observe proficiencies and
                trends.
              </li>
              <li>
                The SKILL SET module offers 24 levels of exploration based on
                the popular 24® Game.
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '10',
        header: 'What are "Linked Teams" on my Teacher Homepage?',
        content: (
          <div className="faq-content">
            <p>
              All of the teams assigned to you are linked so you can easily
              toggle between them on your Dashboard (homepage).
            </p>
          </div>
        )
      },
      {
        key: '11',
        header: 'What is the Player Of The Day?',
        content: (
          <div className="faq-content">
            <p>
              Each morning, your Team's PLAYER OF THE DAY is displayed on your
              Teacher Home Page. On Tuesday through Saturday, the POTD is the
              student who earned the most stickers during the previous 24-hour
              period. (Example: Thursday's POTD will show the player who earned
              the most stickers from 12:00 am to 11:59 pm on Wednesday.)
              Monday's POTD is a sum of Friday/Saturday/Sunday stickers earned.
              Note: POTD will not be displayed if students have not earned any
              stickers on the previous day. Teachers can send POTD certificates
              to student - including cases of ties. (1 Sticker is no longer
              eligible for POTD).
            </p>
          </div>
        )
      },
      {
        key: '12',
        header:
          'Can I move a student from one of my teams to another one of my teams?',
        content: (
          <div className="faq-content">
            <p>
              Yes. A classroom teacher can move players across their linked
              teams, and/or to and from an 'Unassigned' classroom for their
              grade level, as well as to or from a Deactivated Students list. On
              your Teacher Homepage, click the Team Management, then click the
              "Move students" link to begin. See: *How do I use the Team
              Leader's Move Students tool?*.
            </p>
          </div>
        )
      },
      {
        key: '13',
        header: 'Other types of student transfers.',
        content: (
          <div className="faq-content">
            <p>
              If the student will be moving between classrooms of the same grade
              level, the teacher of the Team the student is currently in can
              place him/her in the 'Unassigned Team' for that grade level via
              the Team Roster page by selecting "remove a student from team and
              move to unassigned." The NEW classroom teacher would use the 'Move
              Students' tool to bring that student from the Unassigned Team to
              their classroom Team. Student transfers occur instantly, there is
              no waiting period.
            </p>
            <ul>
              <li>
                For more complicated transfers, such as one where the student is
                switching grade levels, the Principal-level (School
                Administrator) can use their 'Move Students' tool to move
                students across various teams (classrooms) and teachers. This
                view gives a list of all the classrooms within the school and
                provides options for searching for specific teachers, grade
                levels, or students.
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '14',
        header: 'Can I get help with student transfers?',
        content: (
          <div className="faq-content">
            <p>
              Yes! You can call 800-242-4542 or 610-253-5255 (Live support 9-4
              ET) with your transfer request information and we can make the
              changes for you! *Players cannot be transferred from a previous
              year into the current year.*
            </p>
          </div>
        )
      },
      {
        key: '15',
        header: 'How do I use the Team Leader’s Move Students tool?',
        content: (
          <div className="faq-content">
            <p>
              The ‘Move Students’ tool, accessible from the Team Leader Home
              Page or Team Roster page, allows teachers to see all their
              classrooms and move players between those classrooms. The main
              Interface displays all of your teams, plus an ‘Inactive Students’
              list and one or more ‘Unassigned’ Grade teams, depending on the
              number of grades you teach. A convenient SEARCH box allows you to
              find a student by name or District ID Number.
            </p>
            <ul>
              <li>
                To move a student you must first select the Team that student is
                on. If you know the Team, click and drag it to left side of the
                screen below the Search box — the area will turn green
                indicating you can drop the team there. *If you are not sure
                which Team the student is on, type some student info into the
                “enter player info to search” box.* Once the Team you’ve
                selected is on the left panel you may drag any student on that
                panel into another classroom by clicking on their gray box and
                dragging it over any Team. As you drag a student over a team it
                will turn green indicating they can be placed there. A
                confirmation window will appear that the student has been moved.
                NOTE: Any active Family Link members will also be moved as part
                of this process.
              </li>
              <li>
                If the classroom you wish to move a student to is not one of
                yours, drag them to the Unassigned Team for that grade, and that
                teacher or school building administrator can complete the
                process. If the student has left the school building, you may
                move them to the Inactive Students list.
              </li>
              <li>
                Pro Tip: Click on a Team (without dragging it) to display a
                pop-up menu showing the students on that Team. Mouse over the
                contents to see more information. Be sure to close the pop-up
                before trying to move students.
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '16',
        header: 'How do I use the Admin/Principal Move Students tool?',
        content: (
          <div className="faq-content">
            <p>
              The Admin/Principal-level version of the Move Students tool allows
              any student to be moved across teams of different teachers.
              Because the number of classrooms can become quite large,
              additional tools are provided to search by teacher, or filter by
              grade level. In all other regards this tool functions like the
              Team level tool. Click "School Managment" then "Move Players" to
              begin.
            </p>
          </div>
        )
      },
      {
        key: '17',
        header: 'Can a student be deleted?',
        content: (
          <div className="faq-content">
            <p>
              Students can be fully Deactivated and removed from your Team
              (classroom), but their data will not be permanently deleted; they
              can be recovered indefinitely. A Deactivated student can no longer
              log in and will be unable to do so until they are reactivated by
              being placed on a team. *You can functionally remove a student by
              erasing their fields including Display Name, ID Number, and
              alternate credentials, deactivate them and then create a new
              student from your team roster page (Add an individual student)*.
              If you wish to permanently erase a student’s data including all
              their stickers, please contact First In Math Tech Support. This
              process is not reversible.
            </p>
          </div>
        )
      },
      {
        key: '18',
        header: 'What are "Deactivated Students"?',
        content: (
          <div className="faq-content">
            <p>
              A Deactivated/Inactive student is a student who is no longer
              attached to your team (or any team), and can no longer log in. You
              can deactivate a student from the Team Roster by clicking the menu
              icon to the left of the display name and selecting “Deactivate
              this Student”. When a student is deactivated, their data—including
              their sticker count—is preserved. Students can be reactivated
              using the ‘Move Player ‘tool to assign them to a team (classroom).
            </p>
            <ul>
              <li>
                A student may be deactivated for administrative reasons or
                because the student is no longer at the school. In some
                instances when data is synchronized from a District SIS (Student
                Information System) students are removed from the data feed, in
                which case they will be classified as Deactivated until they are
                added back into the data feed.
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '19',
        header: 'What does Class Name  ‘ — UNASSIGNED – Grade {x} ‘  mean?',
        content: (
          <div className="faq-content">
            <p>
              A student whose classroom teacher is unknown will be held in a
              team specifically for that grade level with an ‘Unassigned’
              designation. *(This could happen because they were removed from a
              classroom via “remove student from team and move to unassigned” or
              because their data synchronized in a way that the classroom and
              teacher could not be determined. This could be due to multiple
              classroom assignments which First In Math does not recognize, or
              because a teacher moved the student into one of these unassigned
              grade level place holders.)* While on an Unassigned team a student
              may still log in and have their progress recorded—allowing them to
              play before knowing what their proper team assignment is. To
              assign a student to team, the teacher can use the ‘Move Students’
              tool from their dashboard. This can also be done from the ‘Move
              Students’ tool from the School Administrator Page (Principal
              level).
            </p>
          </div>
        )
      },
      {
        key: '20',
        header: 'Why am I seeing different, new FIRST IN MATH Usernames?',
        content: (
          <div className="faq-content">
            <p>
              Going forward, First In Math usernames are five randomly-generated
              characters instead of an extension of a Team name. This change was
              made to eliminate confusion for students moving across classrooms,
              and will allow them to retain one consistent Username. (This also
              includes any FAMILYLINK player associated with the account.)
              Previously, students that are part of rostering often saw their
              Usernames change repeatedly.
            </p>
          </div>
        )
      },
      {
        key: '21',
        header: 'What is a Skill Set® group?',
        content: (
          <div className="faq-content">
            <p>
              A Skill Set® group is comprised of three sequential 24® game
              editions, labeled Game 1, Game 2 and Game 3. Each edition builds
              upon the skills acquired in previous editions. Games present a
              range of difficulty, and may contain 1 Dot cards (easy); 2 Dot
              cards (medium) and/or 3 Dot cards (tough). The Skill Set® groups,
              numbered one through eight, focus on the skills that students
              should learn for each grade level.
            </p>
          </div>
        )
      },
      {
        key: '22',
        header: 'Skill Set® 1',
        content: (
          <div className="faq-content">
            <p>
              Students using Skill Set® 1 will gain proficiency in simple
              addition and subtraction facts for numbers 1 through 24 and
              improve numerical fluency and critical-thinking skills.
            </p>
            <ul>
              <li>
                - Game 1 - Add Only 1 Dot cards. One-step addition problems,
                using the numbers 0-12.
              </li>
              <li>
                - Game 2 - Subtract Only 1 Dot cards. One-step subtraction
                problems, using the numbers 0-12.
              </li>
              <li>
                - Game 3 - Add and Subtract Only 2 Dot cards. One-step addition
                or subtraction problems, using the numbers 0-24.
              </li>
            </ul>
            <p>
              Also see our [graphic overview of Skill Set® 1 and sample
              cards](popup:/explore/popups/skill-sets?ss=1).
            </p>
          </div>
        )
      },
      {
        key: '23',
        header: 'Skill Set® 2',
        content: (
          <div className="faq-content">
            <p>
              Students using Skill Set® 2 will continue to practice addition and
              subtraction facts, learn how to combine three numbers by
              understanding simple grouping skills, and begin to recognize
              patterns, thus improving problem-solving skills.
            </p>
            <ul>
              <li>
                - Game 1 - Add/Subtract 1 Dot cards. One-step problem solving.
                Student determines which operation (addition or subtraction)
                will be needed to correctly solve game card.
              </li>
              <li>
                - Game 2 - Add/Subtract 2 Dot cards. Two-step problem solving.
                Players add or subtract three numbers to create the target
                numbers 3 through 10.
              </li>
              <li>
                - Game 3 - Add/Subtract 3 Dot cards. Two-step problem solving,
                finding patterns to make the target number 24.
              </li>
            </ul>
            <p>
              Also see our [graphic overview of Skill Set® 2 and sample
              cards](popup:/explore/popups/skill-sets?ss=2).
            </p>
          </div>
        )
      },
      {
        key: '24',
        header: 'Skill Set® 3',
        content: (
          <div className="faq-content">
            <p>
              Students using Skill Set® 3 will gain proficiency in simple
              multiplication and division facts for the fact families 1 through
              10, and practice using all four math operations (addition,
              subtraction, multiplication and division). Players also improve
              numerical fluency and problem-solving skills.
            </p>
            <ul>
              <li>
                - Game 1 - Multiply Only 1 Dot and 2 Dot cards. One-step
                multiplication problems. 1 Dot cards focus on the fact families
                for numbers 1, 2, 5 and 10. 2 Dot cards focus on the fact
                families for numbers 3, 4, 6, 7, 8 and 9.
              </li>
              <li>
                - Game 2 - Divide Only 1 Dot and 2 Dot cards. One-step division
                problems. 1 Dot cards focus on the fact families for numbers 1,
                2, 5 and 10. 2 Dot cards focus on the fact families for numbers
                3, 4, 6, 7, 8 and 9.
              </li>
              <li>
                - Game 3 - Multiply/Divide 1 Dot cards. One-step problem
                solving. Player determines which operation (addition,
                subtraction, multiplication or division) will correctly solve
                for the target numbers 3 through 10.
              </li>
            </ul>
            <p>
              Also see our [graphic overview of Skill Set® 3 and sample
              cards](popup:/explore/popups/skill-sets?ss=3).
            </p>
          </div>
        )
      },
      {
        key: '25',
        header: 'Skill Set® 4',
        content: (
          <div className="faq-content">
            <p>
              Students using Skill Set® 4 will continue to gain speed, accuracy
              and proficiency in all four operations, learn how to combine four
              numbers, look for patterns, practice order of operations, engage
              in critical thinking, refine problem-solving and increase
              numerical fluency.
            </p>
            <ul>
              <li>
                - Game 1 - Multiply/Divide 2 Dot cards. Two-step problem
                solving. Players add, subtract, multiply and divide three
                numbers to make the target numbers 3 through 10. (A "hint"
                appears during the first round; during the second round the hint
                no longer appears.)
              </li>
              <li>
                - Game 2 - Multiply/Divide 3 Dot cards. Two-step problem
                solving, to make the number 24.
              </li>
              <li>
                - Game 3 - Single Digits 1 Dot and 2 Dot cards. Three-step
                problem solving, to make the number 24. 1 Dots are an easier
                introductory level where many cards have multiple solutions. 2
                Dots are more challenging.
              </li>
            </ul>
            <p>
              Also see our [graphic overview of Skill Set® 4 and sample
              cards](popup:/explore/popups/skill-sets?ss=4).
            </p>
          </div>
        )
      },
      {
        key: '26',
        header: 'Skill Set® 5',
        content: (
          <div className="faq-content">
            <p>
              Students using Skill Set® 5 will continue to gain proficiency in
              using all four operations (with an emphasis on double-digit
              numbers), pattern recognition, critical thinking, problem solving
              and numerical fluency. Players will begin adding and subtracting
              fractions with like and unlike denominators and reducing them to
              their simplest form.
            </p>
            <ul>
              <li>
                - Game 1 - Fractions Primer (+ -) 1 Dot & 2 Dot cards. One-step
                problem solving. Player determines which operation, addition or
                subtraction, will be needed to correctly solve game card for the
                target numbers 1/4, 1/3, 3/8, 1/2, 5/8, 2/3, 3/4 and 7/8. 1 Dot
                cards have like denominators, 2 Dot cards have unlike
                denominators. Answers are in simplest form..
              </li>
              <li>
                - Game 2 - Double Digits 1 Dot and 2 Dot cards. Three-step
                problem solving with an emphasis on double digits, to make the
                number 24. 1 Dot cards are the easier introductory level. 2 Dots
                are more challenging.
              </li>
              <li>
                - Game 3 -Decimal Primer 1 Dot & 2 Dot cards. One- and two-step
                problem solving. Student determines which operation will be
                needed to correctly solve game card for the target numbers .05,
                .1, .2, .25, .3, .4, .5, .6, .7, .75, .8, .9 .
              </li>
            </ul>
            <p>
              Also see our [graphic overview of Skill Set® 5 and sample
              cards](popup:/explore/popups/skill-sets?ss=5).
            </p>
          </div>
        )
      },
      {
        key: '27',
        header: 'Skill Set® 6',
        content: (
          <div className="faq-content">
            <p>
              Students using Skill Set® 6 will apply all four operations with
              whole numbers, decimals, and fractions in Games 1 and 3. Game 2
              will begin using pre-algebraic concepts of looking for unknown
              numbers. Players will increase proficiency in problem solving,
              numerical fluency and pattern recognition. They will begin lateral
              thinking and expand concentration and memory skills.
            </p>
            <ul>
              <li>
                - Game 1 - Decimals 1 Dot and 2 Dot cards. Three-step problem
                solving using decimals and whole numbers to make the number 24.
                1 Dot cards are the easier introductory level. 2 Dots are more
                challenging.
              </li>
              <li>
                - Game 2 - Variables cards. Cards feature multi-step problem
                solving using addition, subtraction, multiplication, division
                and introducing the pre-algebra concept of looking for an
                unknown. Target number is 24.
              </li>
              <li>
                - Game 3 - Fractions Primer (x ÷) 1 Dot and 2 Dot cards. 1 Dot
                cards are a one-step problem using all four operations and
                combining proper and improper fractions and/or whole numbers to
                reach the target numbers 3, 4, 6 and 8. 2 Dot cards require
                two-step problem solving.
              </li>
            </ul>
            <p>
              Also see our [graphic overview of Skill Set® 6 and sample
              cards](popup:/explore/popups/skill-sets?ss=6).
            </p>
          </div>
        )
      },
      {
        key: '28',
        header: 'Skill Set® 7',
        content: (
          <div className="faq-content">
            <p>
              Students using Skill Set® 7 will focus on refining the
              manipulation of fractions and whole numbers, begin using integers
              (positive and negative numbers) and algebraic expressions (x,y).
              In addition, players will continue to practice problem solving,
              pattern recognition, critical thinking, concentration and
              numerical fluency.
            </p>
            <ul>
              <li>
                - Game 1 - Fractions 1 & 2 Dot. Multi-step addition,
                subtraction, multiplication and division with whole numbers and
                fractions. Target number is 24. 1 Dot is an introductory level.
                2 Dot is more challenging.
              </li>
              <li>
                - Game 2 - Integers 1 & 2 Dot. Multi-step addition, subtraction,
                multiplication and division using single-digit integers
                (positive and negative numbers). Target number is positive 24. 1
                Dot is an introductory level. 2 Dot is more challenging.
              </li>
              <li>
                - Game 3 - Algebra 1 Dot. Multi-step addition, subtraction,
                multiplication and division of single-digit numbers using
                algebraic notation. Target number is 24. x or y can be any whole
                number, 2 to 9.
              </li>
            </ul>
            <p>
              Also see our [graphic overview of Skill Set® 7 and sample
              cards](popup:/explore/popups/skill-sets?ss=7).
            </p>
          </div>
        )
      },
      {
        key: '29',
        header: 'Skill Set® 8',
        content: (
          <div className="faq-content">
            <p>
              Students using Skill Set® 8 will focus on simple exponents, roots,
              simplifying, factoring and evaluating algebraic expressions using
              one or two variables. These expressions progressively increase in
              difficulty from 2 to 3 Dot cards. In addition, players continue to
              practice problem solving, pattern recognition, sequential
              thinking, simultaneous thinking, concentration and numerical
              fluency.
            </p>
            <ul>
              <li>
                - Game 1 - Exponents 1 & 2 Dot. Multi-step addition,
                subtraction, multiplication and division using exponent
                operations. Target number is 24. Square, cube, take the square
                root or cube root of any number on the card, or a computed
                number to reach 24. 1 Dot is an introductory level. 2 Dot is
                more challenging.
              </li>
              <li>
                - Game 2 - Algebra 2 Dot. Multi-step addition, subtraction,
                multiplication and division using algebraic notation. Players
                must simplify algebraic expressions before solving the card.
                Target number is 24. 2 Dot Algebra cards are more complex than 1
                Dot cards found in Skill Set 7.
              </li>
              <li>
                - Game 3 - Algebra 3 Dot. Multi-step addition, subtraction,
                multiplication and division using algebraic notation. Players
                must simplify algebraic expressions before solving the card.
                Target number is 24. 3 Dot Algebra cards are complex and may
                contain more than one algebraic expression and include fractions
                containing x and/or y.
              </li>
            </ul>
            <p>
              Also see our [graphic overview of Skill Set® 8 and sample
              cards](popup:/explore/popups/skill-sets?ss=8).
            </p>
          </div>
        )
      },
      {
        key: '30',
        header: 'How are stickers earned?',
        content: (
          <div className="faq-content">
            <p>
              Students earn stickers when they answer questions correctly.
              Consult individual game Directions for specific information on
              scoring, rules, etc.
            </p>
          </div>
        )
      },
      {
        key: '31',
        header: 'What is my Player Badge?',
        content: (
          <div className="faq-content">
            <p>
              The round icon that appears in the center of your Player HUB is
              your Player Badge, and is indicative of your skill level in the
              program (based on stickers earned). Customize your icon by
              selecting a custom design instead of the default skill icon.
            </p>
          </div>
        )
      },
      {
        key: '32',
        header: 'Hints for competitive play—how champions are made.',
        content: (
          <div className="faq-content">
            <p>
              Bonus "Wheel-Type" games (TEN WHEELS, FACTORS, 24 WHEELS and
              FRACTION WHEELS) are referred to as the "Land Where Champions Are
              Made." These games offer patient players the opportunity to earn
              lots of stickers.
            </p>
            <ul>
              <li>
                If you are serious about competing to be a top player, take your
                time and make sure that you score the maximum number of stickers
                for each round of play. For example, if you score a maximum 12
                stickers for each play in Ten Wheels that is great, but if you
                rush and only earn 6 stickers per play, you will only earn half
                the potential stickers available. Each year, the top-scoring
                players make sure they earn the maximum amount of stickers on
                each and every game – it takes incredible patience and
                dedication.
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '33',
        header: 'What is a Power Jump?',
        content: (
          <div className="faq-content">
            <p>
              The Power Jump allows a player who is proficient to quickly
              complete a Skill Set game and move to the next level of challenge.
              In both rounds, you have the option to Power Jump after completing
              the first two boxes. If you elect to Power Jump and succeed, then
              all the boxes in the scoreboard will fill in for that round. If
              you do not succeed, there is no penalty, and you must complete the
              round one box at a time.
            </p>
          </div>
        )
      },
      {
        key: '34',
        header: 'What are the "GYMs"?',
        content: (
          <div className="faq-content">
            <p>
              The fact-practice GYMs are a great place to improve automaticity,
              accuracy and speed in all areas. Games are fast-paced, and have a
              short cycle of play that students enjoy. A Strength Meter charts
              progress within each fact. Silver Stars show proficiency. Earning
              a GOLD STAR demonstrates mastery of a fact family.
            </p>
          </div>
        )
      },
      {
        key: '35',
        header: 'What is JUST THE FACTS?',
        content: (
          <div className="faq-content">
            <p>
              The Just The Facts module "tests" students' knowledge of basic
              facts. Designed to be used in place of cumbersome
              "pre-test/post-test" worksheets. Full assessment of each student's
              skill improvement is accessible from the Teacher Home Page.
            </p>
            <ul>
              <li>
                Choose content area: Whole Numbers; Fractions; Decimals or
                Integers. Within each unit select an Operation: Add; Subtract;
                Multiply or Divide. In addition to pre-est and post-test
                function, tests can be taken at any time to build automaticity
                with addition, subtraction, multiplication and division facts.
                Silver Stars & Gold Stars: A Silver Star shows that the student
                has completed the PRE-TEST. A Gold Star shows that the student
                has completed that operation (The gold star is triggered when
                the student hits 95% correct on the Post-Test.)
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '36',
        header: 'What are KNOW & SHOW modules?',
        content: (
          <div className="faq-content">
            <p>
              Know & Show modules allow students to review and practice skills
              that will be helpful when taking standardized mathematics tests.
              Grades are separated by grade level. All levels concentrate on
              grade-appropriate material. Students solve problems from
              categories that directly correlate to test content. Students
              correctly answer a specified number of questions to earn stickers.
              Questions selected randomly for each session.
            </p>
          </div>
        )
      },
      {
        key: '37',
        header: 'What is FAMILYLINK®?',
        content: (
          <div className="faq-content">
            <p>
              FamilyLink® involves family members! For each student enrolled in
              the First In Math® program, we automatically create one additional
              User ID for a family member or friend to use! The FamilyLink User
              ID appears on the student's Homepage. FamilyLink players have full
              access to site content 24/7, and automatically become part of
              their own exciting, friendly competition.
            </p>
            <ul>
              <li>
                FamilyLink® players compete in their own separate Rankings.
                Student and family member sticker counts are combined for a
                Family Team total score, providing a mechanism for students and
                families to spur each other on to greater mathematics
                achievement. (Family sticker-count totals do not count toward
                Student or Team Rankings, only Family Team Rankings).
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '38',
        header: "Why aren't all games accessible on the Skill Set hubs?",
        content: (
          <div className="faq-content">
            <p>
              Skill Sets that appear for each player are determined by their
              FOCUS MODE assignment. For example, If a student is in EARLY focus
              mode, only Skill Sets 1, 2 and 3 will be visible.
            </p>
          </div>
        )
      },
      {
        key: '39',
        header: 'What are Assessment Reports?',
        content: (
          <div className="faq-content">
            <p>
              Reports show live statistics and data, allowing teachers,
              principals and administrators to view and assess student progress
              at any time. Data can be easily exported into Excel spreadsheet
              files. Students are listed by FIM User ID/reference name. Teams
              are listed by Class Name or Team Name, and can be sorted by
              categories such as Grade, Module or Activity (sticker count).
              Assessment Reports are not available to students.
            </p>
            <ul>
              <li>
                Team Assessment Report: Shows progress data for one Team
                (class). Sort by Skill Set, Gym, Measurement World, Bonus, K&S,
                or Activity (sticker count). Can be viewed by Teachers,
                Principals, District/Area Coordinators and School System
                Coordinators.
              </li>
              <li>
                Team Summary/Assessment Report: Principals can access combined
                statistics for all participating classes within their school.
                These reports show each participating school&apos;s progress by
                Grade composite. Activation data, year-to-year comparisons and
                Teacher info is also available. Can be viewed by Principals and
                District/Area or School System Coordinators.
              </li>
              <li>
                District/Area Report: District or Area-wide reports are
                available to assigned First In Math® Coordinators at the
                District/Area level.
              </li>
              <li>
                School System Report: Reports are available to a School
                System&apos;s assigned First In Math® Coordinator only.
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '40',
        header: 'What are Rankings?',
        content: (
          <div className="faq-content">
            <p>
              RANKING pages show data for users currently playing. Select the
              type of Rankings you would like to view: Top Schools; Top Teams;
              Top Players (listed by User ID), Top Educators, Top Family Players
              and Top Family Teams. (Categories are further divided by National,
              State, School District and School.)
            </p>
          </div>
        )
      },
      {
        key: '41',
        header: 'How to "Add" a Student.',
        content: (
          <div className="faq-content">
            <p>
              From the Teacher/Team Leader Homepage, click &quot;Team
              Management&quot; then &quot;Team Roster&quot; - click the
              &quot;Add an individual student&quot; (or &quot;Add multiple
              students&quot;) button. Enter a Display Name for the student(s).
              Click &quot;SAVE&quot; to create a new player or hit
              &quot;Cancel&quot;. Clicking SAVE creates the new login and
              password.
            </p>
          </div>
        )
      },
      {
        key: '42',
        header: 'Privacy - Who has access to my class information?',
        content: (
          <div className="faq-content">
            <p>
              The First In Math® site is proud to be a signatory of the STUDENT
              PRIVACY PLEDGE, and is also in full compliance with the
              Children&apos;s On-line Privacy Protection Act (COPPA). The FIM
              site does not specifically request any personal or individually
              identifiable information about your students. All participants are
              identified by the player&apos;s randomly-assigned User ID.
              Information you supply about your school or organization to
              register your team will not be shared with third parties.
            </p>
            <ul>
              <li>
                NO ONE can access the information for your team without the
                proper User ID & Password. Authorized employees of Suntex
                International Inc. (site administrator) can access data for
                administrative purposes. See Privacy Policy.
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '43',
        header: 'Privacy Policy',
        content: (
          <div className="faq-content">
            <p>
              Here&apos;s a link to our [Full Privacy
              Policy](https://explore.firstinmath.com/privacy?cc=us).
            </p>
          </div>
        )
      },
      {
        key: '44',
        header: 'Can students play at home?',
        content: (
          <div className="faq-content">
            <p>
              YES, students can log on and play at home from any device with
              Internet access!
            </p>
          </div>
        )
      },
      {
        key: '45',
        header: 'Can I use FIM on an iPad or other Phone/Tablet device?',
        content: (
          <div className="faq-content">
            <p>
              FIM is accessible directly on current tablets and smart phones.
              When children log in at firstinmath.com with their User ID and
              Password for the current school year, they will see their Player
              Hub.
            </p>
          </div>
        )
      },
      {
        key: '46',
        header: 'What if I lose or forget my Teacher User ID or Password?',
        content: (
          <div className="faq-content">
            <p>
              Click the &quot;I forgot my login&quot; link on the main landing
              page and we will email your information. (The email address you
              provide must match the email address we have on file for you).
              IMPORTANT! Keep your Password a secret to discourage students
              &quot;hacking&quot; into your TL page and potentially deleting
              players!
            </p>
          </div>
        )
      },
      {
        key: '47',
        header: 'What if a student forgets his/her User ID or Password?',
        content: (
          <div className="faq-content">
            <p>
              View your student&apos;s User ID&apos;s and Passwords online.
              Click the Team Management, thenTeam Roster link on your Team
              Leader Dashboard/Homepage to see all User info.
            </p>
          </div>
        )
      },
      {
        key: '48',
        header: 'Can a Team Leader play games?',
        content: (
          <div className="faq-content">
            <p>
              YES!!! Teachers can play all games accessible to students*. If you
              would like to experience the site through the eyes of a student,
              click your PLAY navigation button at the top of the page. Your
              sticker-count will be saved, and will appear on your
              &#34;player&quot; page, in the Rankings, and in the Winner&apos;s
              Circle Summary data. The stickers you earn will NOT affect your
              Team&apos;s sticker count.
            </p>
            <ul>
              <li>
                **Note**: Team Leaders cannot play games from K-2 World unless
                they are in (or change to) the EARLY Focus Mode. Team Leaders
                can sample these games to assess content by clicking their
                PREVIEW (Practice) tab in the navigation bar.
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '49',
        header: 'How can I involve parents?',
        content: (
          <div className="faq-content">
            <p>
              RECOGNIZE ACHIEVEMENT. Teachers can print out one of the many
              Certificates of Achievement, stickers and badges offered on the
              FIM site, including FamilyLink certificates, by clicking the
              RECOGNITION button on their Team Leader Homepage. Have students
              show their family members.
            </p>
          </div>
        )
      },
      {
        key: '50',
        header: 'How to download a Certificate of Achievement?',
        content: (
          <div className="faq-content">
            <ul>
              <li>Click the RECOGNITION link on your Teacher Homepage</li>
              <li>
                Select the category of art (certificate, brag tag, poster,
                etc.).
              </li>
              <li>Click the art you want to download.</li>
              <li>
                A PDF file will download to the location or folder you have set
                on your computer—many computers download to the desktop by
                default. This should take less than one minute. (If you have
                Adobe Acrobat™ Reader, the file may open right in your browser
                window, and you can print directly from there.)
              </li>
              <li>
                Open the file after it has downloaded and print as many as you
                need. Sign the certificates and distribute to students. Save the
                file if you will need to print more certificates later.*
              </li>
            </ul>
            <p>
              Most devices have software installed that can open PDF files. We
              recommend using Adobe® Reader to open PDF files.
            </p>
          </div>
        )
      },
      {
        key: '51',
        header: 'Is there a non-online version of the First In Math program?',
        content: (
          <div className="faq-content">
            <p>
              No, the First In Math® Online Program is only accessible online.
              However, the innovative teaching tool that the website is based
              upon — the 24® Game — is available as a stand-alone card game.
              Classroom-sized editions have been used in schools around the
              world for more than 30 years. Available in nine
              editions—Add/Subtract Primer, Multiply/Divide Primer,
              Factors/Multiples, Single Digits, Double Digits, Variables,
              Fractions/Decimals, Integers, and Algebra/Exponents (See
              24game.com for age guidelines). 24® Games are printed and
              manufactured in the USA.
            </p>
          </div>
        )
      },
      {
        key: '52',
        header: 'How can I sign up For the First In Math program? ',
        content: (
          <div className="faq-content">
            <p>
              Call Suntex International Inc. at 800-242-4542 or 610-253-5255 and
              ask to speak with one of our customer support specialists. You can
              also e-mail your request to sales@firstinmath.com and someone will
              contact you. Please mention that you are interested in learning
              more about the First In Math® Online Program. Discount rates apply
              for large, district-wide purchases. Call for more information.
            </p>
          </div>
        )
      }

      // Note: Additional FAQ items would continue here in a real implementation
    ]
  },
  {
    title: 'Troubleshooting',
    items: [
      {
        key: '1',
        header: 'Minimum System Requirements',
        content: (
          <div className="faq-content">
            <p>
              Here&apos;s a link to the First In Math [Minimum System
              Requirements](https://explore.firstinmath.com/program-content/system-requirements?cc=us).
            </p>
          </div>
        )
      },
      {
        key: '2',
        header: 'Trouble printing Assessment Reports.',
        content: (
          <div className="faq-content">
            <p>
              Be sure that the &quot;Print colors & background images&quot;
              setting is checked in your print dialog or Page Setup preferences.
              (may be located under page setup in your print dialogue.)
            </p>
          </div>
        )
      },
      {
        key: '3',
        header: 'Why do the Rankings show my team losing stickers?',
        content: (
          <div className="faq-content">
            <p>
              It is generally a common misunderstanding about how our Rankings
              work. The number you see in the Rankings is the AVERAGE Stickers
              per student. As the number of students playing on a team or within
              a school increases, that average can actually go down if a new
              player joins the team—just like when a student performs poorly on
              a test it will affect the class average until the new players
              start earning. Check your Team Sticker Count on your Team Leader
              Home Page for your team&apos;s Total Stickers earned.
            </p>
          </div>
        )
      },
      {
        key: '4',
        header: "Why does it seem that a player isn't earning stickers?",
        content: (
          <div className="faq-content">
            <p>
              When a student feels he/she is not earning stickers it is often a
              simple misunderstanding about how and when stickers can be earned.
              (See How are stickers earned?) The most common issue is that
              students continue to play games that they have
              &quot;finished&quot; and no longer award stickers, or they are
              playing in Practice Mode.
            </p>
            <p>
              If you have carefully checked to determine that a player is indeed
              playing but not earning stickers, it is due to security setting(s)
              within:
            </p>
            <ul>
              <li>your school&apos;s internet/computer system, or</li>
              <li>
                within the browser settings of a particular computer or
                computers
              </li>
            </ul>
            <p>
              Our servers receive data from your computer(s) to record stickers
              earned and track player progress. Your system&apos;s security
              settings can interfere by blocking the data transfer. In
              non-technical terms, the games load and play on your computer, and
              the completion data then travels back to our servers. If the
              transfer of out-bound data is blocked, stickers earned will not be
              recorded.
            </p>
          </div>
        )
      },
      {
        key: '5',
        header: 'How do I reset my cache?  (What is a cache?)',
        content: (
          <div className="faq-content">
            <p>
              You may want to reset (empty) your computer's cache if you player
              seems "stuck" or is not advancing. Your cache is temporary storage
              where frequently accessed data, such as images, are stored for
              rapid access. Deleting it will not harm your computer. After
              emptying the cache you will need to QUIT the browser and reopen
              it.
            </p>
          </div>
        )
      },
      {
        key: '6',
        header: 'Problems getting the game to function',
        content: (
          <div className="faq-content">
            <ul>
              <li>
                Be sure that your computer’s Internet browser is set to ALLOW
                cookies, or you will not be able to log in. The site does not
                track personal information, but uses “cookie” technology to
                record player advancement and status.
              </li>
              <li>
                Make sure JavaScript is enabled within your browser. Although
                the site does not require any plug-ins, JavaScript is required
                for both the site to function as well as the HTML5 game content.
                By default, JavaScript is enabled as every modern site would
                require this, however in some extreme cases security software
                may disable JavaScript. JavaScript should not be confused with
                Java or Java runtime libraries, which our site does not require.
              </li>
              <li>
                Your browser should be the most up-to-date version that your
                computer will allow. The site will not function properly with
                old browsers (see: First In Math Minimum System Requirements ).
                You can usually download the latest UPDATE of your favorite
                browser for free via the web.
              </li>
              <li>
                Security settings are often the culprit when students cannot
                play or earn stickers. Check your browser’s security settings.
                Our servers have to be able to receive data from your computer
                in order to record the number of stickers earned and track the
                progress of game play, and &quot;security&quot; settings
                sometimes interfere by blocking the information transfer.
              </li>
              <li>
                Browser preferences should be set to &ldquo;always load new
                pages&quot; or &#34;always get new pages.&quot; This setting can
                be found in the Preferences area of many popular browsers. You
                do not want to use &quot;cached&quot; pages.
              </li>
              <li>
                If you cannot log on to First In Math®, SmartFilter
                site-blocking software can be the issue. Ask your technology
                staff to put in an exception so that www.firstinmath.com will
                not be blocked by your SmartFilter. In addition, the caching of
                pages is an issue, because some schools integrate SmartFilter
                with high-performance caching proxies hosted on proxy servers.
                When a browsing request goes out, it first hits the proxy
                server, which sits behind the firewall. The proxy server checks
                the SmartFilter control list. If SmartFilter allows the request,
                then the proxy goes out across the Internet and retrieves it
                from the site, saves a copy in its cache, and relays it to the
                browser that requested it. When another request arrives for the
                same page, the proxy returns the cached copy, which has already
                been approved by SmartFilter. Because your browser keeps getting
                an &quot;old&quot; already-cached page, players will not see
                their newest sticker counts.
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '7',
        header: 'Why am I bounced back to the Login Page?',
        content: (
          <div className="faq-content">
            <p>
              Usually a bounceback means you have typed in your login info
              incorrectly. Check and retry.
            </p>
            <p>
              If your login is correct, it could be a problem with
              &quot;Cookies&quot; or another security setting. Our servers have
              to be able to receive data from your computer in order to record
              the number of stickers earned and track the progress of game play,
              and &quot;security&quot; settings interfere by blocking the
              information transfer. (We do not collect or store any personal
              information about the user, or user&apos;s computer—we simply
              track player progress through User IDs and Passwords.)
            </p>
            <ul>
              <p>Make sure your browser adheres to the following:</p>
              <li>ALLOW cookies</li>
              <li>ALLOW javascript</li>
              <li>
                Designate www.firstinmath.com as a &quot;trusted site&quot; in
                your browser&apos;s preferences.
              </li>
            </ul>
            <p>
              Once you have checked/changed these settings, quit and restart
              your browser. You may also need to empty the cache.
            </p>
            <p>
              If you block sites or have a Firewall, you may also have to
              "allow&quot; the FIM site within your firewall, or make FIM a
              Trusted Site in your browser preferences.
            </p>
            <p>
              If you have made all the changes we suggest, the problem can be
              with some type of security or filtering that you have through your
              Internet Provider (IP). Your IP could be using filtering with or
              without your knowledge. You also could have installed third-party
              software on your computer (McAfee, Norton’s or something similar)
              that is causing the problem. You may need to research ways you can
              get around your computer’s security to allow the FIM site.
            </p>
          </div>
        )
      },
      {
        key: '8',
        header: "I'm having trouble with FIM, but other sites are fine",
        content: (
          <div className="faq-content">
            <p>
              You may be having trouble with the FIM site because you are asking
              your computer to interact with our servers, not just surf web
              pages, as on other sites. Our servers must be able to receive data
              from your computer to record the number of stickers earned and
              track the progress of game play through “cookies” stored within
              your browser when you log in to the site. Your computer’s security
              settings can interfere by blocking the data transfer, and the site
              may not function properly or you may not be able to log in at all.
              NOTE: If you need to tell your security hardware/software or
              firewall to "ALLOW" the First In Math site, the best thing to do
              is allow ALL FIM addresses, like this: *.firstinmath.com - If you
              cannot use this approach, and need to put in specific addresses,
              use this: www.firstinmath.com
            </p>
          </div>
        )
      },
      {
        key: '9',
        header: 'Why am I seeing strange popups and ads?',
        content: (
          <div className="faq-content">
            <p>
              First In Math servers are protected by industry-standard
              Antivirus, Hardware & Software firewalls, as well as a strict
              Access Control List. Any ad popups you or your students may be
              seeing do not originate from within the FIM site. If your computer
              or tablet device is displaying messages or popups it is infected
              with a virus. These messages may appear as though they&apos;re
              coming from our site when in fact they are not.
            </p>
          </div>
        )
      },
      {
        key: '10',
        header: 'Player stickers are not registering in my lab ',
        content: (
          <div className="faq-content">
            <p>
              SmartFilter site-blocking software can be a problem. Ask your
              technology staff to put in an exception so that
              www.firstinmath.com will not be blocked by your SmartFilter. In
              addition, the caching of pages is an issue, because some schools
              integrate SmartFilter with high-performance caching proxies hosted
              on proxy servers. When a browsing request goes out, it first hits
              the proxy server, which sits behind the firewall. The proxy server
              checks the SmartFilter control list. If SmartFilter allows the
              request, then the proxy goes out across the Internet and retrieves
              it from the site, saves a copy in its cache, and relays it to the
              browser that requested it. When another request arrives for the
              same page, the proxy returns the cached copy, which has already
              been approved by SmartFilter. Because the browser keeps getting an
              "old" already-cached page, players will not see their newest
              sticker counts.
            </p>
          </div>
        )
      },
      {
        key: '11',
        header: 'Classroom Networking Issues',
        content: (
          <div className="faq-content">
            <p>
              In some situations, such as a school's computer lab, computers may
              be networked together. Some large networks are managed by
              third-party software and in some situations each computer is
              assigned a network ID or password. If all of the computers on the
              network are using the same ID or password, the First In Math® game
              may be unable to identify which computer/student to send the
              proper game-completion data to. To avoid problems, all computers
              on your network should have a unique network password.
            </p>
          </div>
        )
      },
      {
        key: '11',
        header: 'Who should I contact if the site is not functioning properly?',
        content: (
          <div className="faq-content">
            <p>
              First, please make sure you have visited our "Minimum System
              Requirements" page, and read all other applicable portions of this
              HELP section. Nearly all problems can be solved by following
              procedures outlined right here in the HELP section.
            </p>
            <ul>
              <li>
                PLEASE CONSULT THE PERSON RESPONSIBLE FOR THE SETUP AND
                MAINTENANCE OF YOUR SCHOOL'S INTERNET CONNECTION OR FIREWALL
                before contacting us. Many functionality problems are the result
                of a firewall or blocking software (such as SmartFilter) your
                school may have installed to protect students from downloading
                improper material . Ask your technology staff to put in an
                exception so that www.firstinmath.com will not be blocked by
                your filter. In addition, the caching of pages is an issue,
                because some schools integrate filtering software with caching
                proxies hosted on proxy servers. If you do need to contact us,
                you can do so from links on your Teacher Home Page. In all
                cases, the amount of information you provide when you make your
                request will determine how efficiently we can help you. Be as
                detailed as possible in describing the problem, and include all
                relevant information. Support is offered from 8am to 4pm EST,
                Monday - Friday.
              </li>
            </ul>
          </div>
        )
      },
      {
        key: '12',
        header: "I don't see my issue or question here",
        content: (
          <div className="faq-content">
            <p>
              Contact us with questions or concerns anytime via
              info@firstinmath.com and we will get back to you ASAP. Please
              include your name, your school and a brief description of your
              concern or question. You can also call 800-242-4542 to speak with
              one of our friendly customer care specialists Monday-Friday from
              8am to 4pm Eastern.
            </p>
          </div>
        )
      },
      {
        key: '13',
        header: 'First In Math Tech Support',
        content: (
          <div className="faq-content">
            <p>
              The First In Math® Online Program provides free tech support to
              schools, or to users who have purchased individual site licenses.
            </p>
            <p>
              As a courtesy, we try to assist any parent whose child is logging
              in at home and has already tried the suggestions offered here and
              our [troubleshooting
              page](https://explore.firstinmath.com/troubleshooting).
            </p>
            <p>
              This help is offered from 8am to 4pm EST, Monday - Friday via:
            </p>
            <ul>
              <li>phone: 800-242-4542</li>
              <li>
                email: [info@firstinmath.com](mailto:info@firstinmath.com)
              </li>
              <li>
                our [Contact Us form]
                <a href="/">(https://explore.firstinmath.com/contact?cc=us)</a>
              </li>
            </ul>
          </div>
        )
      }
      // Note: Additional troubleshooting items would continue here
    ]
  }
]

/**
 * returns JSX for teacher FAQ
 */
function TeacherFAQ() {
  return (
    <Flex vertical>
      {/* heading */}
      <div className="main-navigation">
        <Flex justify="space-between" align="center">
          <h3 className="main-navigation__heading">FAQs</h3>
          <div className="report-search">
            <Input placeholder="Search..." prefix={<images.SearchIcon />} />
          </div>
        </Flex>
      </div>

      {/* faq list */}
      <div className="main-result">
        <ul className="resources-column-wrapper">
          <li className="resources-column">
            {faqData.map((section) => (
              <ResourceList key={section.title} title={section.title}>
                <Collapse
                  panels={section.items}
                  className="suntex-collapse--faq suntex-collapse-svg"
                />
              </ResourceList>
            ))}
          </li>
        </ul>
      </div>
    </Flex>
  )
}

export default TeacherFAQ
